/* eslint-disable camelcase */
export const isLogin = () => {
  const token = localStorage.getItem("token");
  const is_authenticated = localStorage.getItem("is_authenticated");

  if (!token || !is_authenticated || is_authenticated === "0") {
    return false;
  }
  return true;
};

export const getUserId = () => {
  return localStorage.getItem("userId") || null;
};

export const formatDate = (dateStr) => {
  // if (dateStr) {
  //   const [year, month, day] = dateStr?.split("-");
  //   let newDate = `${month}-${day}-${year}`;
  //   return newDate;
  // } else {
  //   return dateStr;
  // }
  const date = new Date(dateStr);

  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  // Extract the month, day, and year from the Date object
  const month = monthNames[date.getMonth()];
  const day = date.getDate();
  const year = date.getFullYear();

  // Format the date as 'Jul 10, 2024'
  const formattedDate = `${month} ${String(day).padStart(2, "0")}, ${year}`;
  return formattedDate;
};

export const dateSendToBackend = (dateStr) => {
  // const [month, day, year] = dateStr?.split("/");

  // const formattedDate = `${year}/${month}/${day}`;
  const date = new Date(dateStr);

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-based, so add 1
  const day = String(date.getDate()).padStart(2, "0");

  const formattedDate = `${year}/${month}/${day}`;

  return formattedDate;
};

export const getDatefromBackend = (dateStr) => {
  // const [year, month, day] = dateStr?.split("-");

  // const formattedDate = `${month}/${day}/${year}`;
  const date = new Date(dateStr);

  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  // Extract the month, day, and year from the Date object
  const month = monthNames[date.getMonth()];
  const day = date.getDate();
  const year = date.getFullYear();

  // Format the date as 'Jul 10, 2024'
  const formattedDate = `${month} ${String(day).padStart(2, "0")}, ${year}`;

  return formattedDate;
};

// export const formatDateToYYYYMMDD = (date) => {
//   const year = date?.getFullYear();
//   const month = String(date.getMonth() + 1).padStart(2, "0"); // getMonth() is zero-based
//   const day = String(date.getDate()).padStart(2, "0");

//   const formattedDate = `${year}/${month}/${day}`;
//   return formattedDate;
// };

export const formatDateToMMDDYYYY = (date) => {
  // const year = date?.getFullYear();
  // const month = String(date.getMonth() + 1).padStart(2, "0"); // getMonth() is zero-based
  // const day = String(date.getDate()).padStart(2, "0");

  // const formattedDate = `${month}/${day}/${year}`;
  const getDate = new Date(date);

  // Define an array of month names for formatting purposes
  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  // Extract the month, day, and year from the Date object
  const month = monthNames[getDate.getMonth()];
  const day = getDate.getDate();
  const year = getDate.getFullYear();

  // Format the date as 'Jul 01, 2024'
  const formattedDate = `${month} ${String(day).padStart(2, "0")}, ${year}`;
  return formattedDate;
};

export function formatDateToMMYYYY(date) {
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const year = date.getFullYear();
  return `${month}/${year}`;
}

export const imageBaseUrl = process?.env?.REACT_APP_IMAGE_BASE_URL;

export const randomString = (length) => {
  let result = "";
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  const charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};

export const randomSecurityCode = (length = 4) => {
  let result = "";
  const characters = "0123456789";
  const charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};

export const convertToSlug = (str) =>
  str
    ?.toLowerCase()
    ?.replace(/ /g, "-")
    ?.replace(/[^\w-]+/g, "");

// export const selectedPaymentType = (array, id) => {
//   let payment_type;
//   for (const a of array) {
//     if (Number(a?.id) === Number(id)) {
//       payment_type = a?.payment_type;
//     }
//   }
//   return payment_type;
// };

export const minimizeName = (name) => {
  let lengthOfName = name?.length;
  if (lengthOfName > 11) {
    let returnName = name?.split("")?.slice(0, 11)?.join("");
    return `${returnName}...`;
  } else {
    return name;
  }
};

export function decodeHTMLEntities(text) {
  const entities = [
    ["amp", "&"],
    ["apos", "'"],
    ["#x27", "'"],
    ["#x2F", "/"],
    ["#39", "'"],
    ["#47", "/"],
    ["lt", "<"],
    ["gt", ">"],
    ["nbsp", " "],
    ["quot", '"'],
  ];
  let newText;
  if (text?.length > 0) {
    for (let i = 0, max = entities?.length; i < max; ++i)
      newText = text.replace(
        new RegExp(`&${entities[i][0]};`, "g"),
        entities[i][1]
      );

    return newText;
  }
  return "";
}

export const plainString = (text) => {
  let plainString = text?.replace(/<[^>]+>/g, "");
  return plainString;
};

export function isImageOrVideo(url) {
  const imageExtensions = ["jpg", "jpeg", "png", "gif", "bmp", "webp"];
  const videoExtensions = ["mp4", "webm", "ogg", "mov", "avi"];

  // Extract file extension
  const extension = url.split(".").pop().toLowerCase();

  if (imageExtensions.includes(extension)) {
    return "image";
  } else if (videoExtensions.includes(extension)) {
    return "video";
  } else {
    return "unknown";
  }
}

export const formateMobileNumber = (value) => {
  if (!value) return value;

  const phoneNumber = value.replace(/[^\d]/g, ""); // Remove all non-digit characters

  const phoneNumberLength = phoneNumber.length;

  if (phoneNumberLength < 4) {
    return phoneNumber;
  }
  if (phoneNumberLength < 7) {
    return `(${phoneNumber.slice(0, 3)})${phoneNumber.slice(3)}`;
  }
  return `(${phoneNumber.slice(0, 3)})${phoneNumber.slice(
    3,
    6
  )}-${phoneNumber.slice(6, 10)}`;
};

export const validateNum = (num) => {
  let normalNum = num.replace(/[()\-]/g, "");
  const regex = /^[0-9]{10}$/;
  return regex.test(normalNum);
};

export const accData = {
  id: 50,
  role_id: 0,
  full_name: "Tannerr Barry",
  first_name: "Tannerr",
  last_name: "Barry",
  user_name: null,
  city_id: 62,
  state_id: 20,
  zip_code: "44056",
  address: "Dolor sint qui aperi",
  email: "ansh.eww@gmail.com",
  phone_number: "9938383889",
  fax: null,
  email_verified_at: null,
  password_reset_token: null,
  profile_image: "1726251311.png",
  is_associate: 0,
  company_name: "Solis Kramer Inc",
  gender: null,
  dob: "2003-02-23",
  status: 1,
  isEmailSpeacialOffer: 1,
  created_at: "2024-09-14T01:15:11.000000Z",
  updated_at: "2024-10-19T00:18:36.000000Z",
  created_by: null,
  updated_by: null,
  ip_address: "122.171.138.189",
  deleted_at: null,
  classified: [
    {
      id: 84,
      cate_id: 25,
      sub_cate_id: 0,
      name: "Branden Stafford",
      description: "Aut eveniet dolorem voluptas modi",
      type: "Premium",
      start_date: "2024-11-12",
      meta_description: "",
      meta_keywords: "",
      contact_detail: "Deleniti sapiente vo",
      contact_person_name: "Kamal Lindsay",
      email: "culugeco@mailinator.com",
      phone_number: "(192)115-7848",
      mobile: null,
      url: null,
      image: null,
      created_by: 50,
      updated_by: 50,
      status: 1,
      created_at: "2024-11-12T17:53:30.000000Z",
      updated_at: "2024-11-12T17:53:30.000000Z",
      deleted_at: null,
      ip_address: "103.112.218.174",
      is_expire: false,
      images: [
        {
          id: 11,
          classified_id: 84,
          image: "17314340100-image.jpg",
          created_at: "2024-11-12T17:53:30.000000Z",
          updated_at: "2024-11-12T17:53:30.000000Z",
          created_by: 50,
          updated_by: 50,
          deleted_at: null,
        },
        {
          id: 12,
          classified_id: 84,
          image: "17314340101-image.jpg",
          created_at: "2024-11-12T17:53:30.000000Z",
          updated_at: "2024-11-12T17:53:30.000000Z",
          created_by: 50,
          updated_by: 50,
          deleted_at: null,
        },
      ],
      payment: {
        id: 38,
        user_id: 50,
        classfied_id: 84,
        type: "Premium",
        checkout_id:
          "cs_test_a1nnj3UGG2nRbK4N7fIpDM4yBsVjfXTc78xlWWYIij3C5m1pwYR00nNd6f",
        amount: "5",
        payment_status: 1,
        purchase_date: "2024-11-12 10:53:31",
        expire_date: "2024-12-12 10:53:30",
        is_current_plan: 1,
        created_at: "2024-11-12T17:53:31.000000Z",
        updated_at: "2024-11-12T17:54:02.000000Z",
        deleted_at: null,
        email_sent: 0,
        email_sent_one: 0,
      },
    },
    {
      id: 83,
      cate_id: 7,
      sub_cate_id: 3,
      name: "Laurel Watkins",
      description:
        "Consectetur sit libero cumque aperiam aspernatur quia sed est duis",
      type: "Premium",
      start_date: "2024-11-13",
      meta_description: "",
      meta_keywords: "",
      contact_detail: "Dolore sed facilis b",
      contact_person_name: "Tanner Wagner",
      email: "pijurove@mailinator.com",
      phone_number: "(151)195-1578",
      mobile: "(123)123-1231",
      url: null,
      image: null,
      created_by: 50,
      updated_by: 50,
      status: 1,
      created_at: "2024-11-12T17:40:48.000000Z",
      updated_at: "2024-11-12T17:40:48.000000Z",
      deleted_at: null,
      ip_address: "42.105.164.107",
      is_expire: false,
      images: [
        {
          id: 8,
          classified_id: 83,
          image: "17314332480-image.jpg",
          created_at: "2024-11-12T17:40:51.000000Z",
          updated_at: "2024-11-12T17:40:51.000000Z",
          created_by: 50,
          updated_by: 50,
          deleted_at: null,
        },
        {
          id: 9,
          classified_id: 83,
          image: "17314332511-image.jpg",
          created_at: "2024-11-12T17:40:51.000000Z",
          updated_at: "2024-11-12T17:40:51.000000Z",
          created_by: 50,
          updated_by: 50,
          deleted_at: null,
        },
        {
          id: 10,
          classified_id: 83,
          image: "17314332512-image.jpg",
          created_at: "2024-11-12T17:40:52.000000Z",
          updated_at: "2024-11-12T17:40:52.000000Z",
          created_by: 50,
          updated_by: 50,
          deleted_at: null,
        },
      ],
      payment: {
        id: 37,
        user_id: 50,
        classfied_id: 83,
        type: "Premium",
        checkout_id:
          "cs_test_a1ZTJjEzUFU4GgROEPZ5gSqdSUJofBS2wYCzVCndzmIlJfIWVdfR7LxYyf",
        amount: "5",
        payment_status: 1,
        purchase_date: "2024-11-12 10:40:53",
        expire_date: "2024-12-12 10:40:52",
        is_current_plan: 1,
        created_at: "2024-11-12T17:40:53.000000Z",
        updated_at: "2024-11-12T17:54:02.000000Z",
        deleted_at: null,
        email_sent: 0,
        email_sent_one: 0,
      },
    },
    {
      id: 82,
      cate_id: 2,
      sub_cate_id: 0,
      name: "Cedric Mayo",
      description: "Quaerat deserunt veniam voluptate est qui hic esse",
      type: "Premium",
      start_date: "2024-11-12",
      meta_description: "",
      meta_keywords: "",
      contact_detail: "Harum elit officiis",
      contact_person_name: "Wesley Hinton",
      email: "zupisejo@mailinator.com",
      phone_number: "(131)796-6269",
      mobile: null,
      url: null,
      image: null,
      created_by: 50,
      updated_by: 50,
      status: 1,
      created_at: "2024-11-12T17:37:08.000000Z",
      updated_at: "2024-11-12T17:37:08.000000Z",
      deleted_at: null,
      ip_address: "103.112.218.174",
      images: [],
      payment: null,
    },
    {
      id: 81,
      cate_id: 2,
      sub_cate_id: 0,
      name: "Germaine Foster",
      description:
        "Est maiores mollit sed harum doloribus quas occaecat nesciunt minim in cillum ea quaerat",
      type: "Premium",
      start_date: "2024-11-13",
      meta_description: "",
      meta_keywords: "",
      contact_detail: "Id voluptas et possi",
      contact_person_name: "Mariam Galloway",
      email: "zobohapi@mailinator.com",
      phone_number: "(131)335-8386",
      mobile: null,
      url: null,
      image: null,
      created_by: 50,
      updated_by: 50,
      status: 1,
      created_at: "2024-11-12T17:31:01.000000Z",
      updated_at: "2024-11-12T17:31:01.000000Z",
      deleted_at: null,
      ip_address: "103.112.218.174",
      images: [],
      payment: null,
    },
    {
      id: 80,
      cate_id: 25,
      sub_cate_id: 0,
      name: "Uma Guerrero",
      description:
        "Cupidatat consequatur reprehenderit cillum harum excepturi aute atque consequatur Autem ut fugiat architecto qui ducimus amet temporibus cupiditate est quaerat",
      type: "Premium",
      start_date: "2024-11-14",
      meta_description: "",
      meta_keywords: "",
      contact_detail: "Harum consequatur Q",
      contact_person_name: "Clark Warren",
      email: "bekeqyto@mailinator.com",
      phone_number: "(117)571-4832",
      mobile: null,
      url: null,
      image: null,
      created_by: 50,
      updated_by: 50,
      status: 1,
      created_at: "2024-11-12T17:24:23.000000Z",
      updated_at: "2024-11-12T17:24:23.000000Z",
      deleted_at: null,
      ip_address: "103.112.218.174",
      images: [],
      payment: null,
    },
    {
      id: 79,
      cate_id: 4,
      sub_cate_id: 0,
      name: "Zena Melton",
      description: "Labore provident ex aut ut modi",
      type: "Premium",
      start_date: "2024-11-14",
      meta_description: "",
      meta_keywords: "",
      contact_detail: "Quos voluptate sed i",
      contact_person_name: "Norman Pope",
      email: "norybixaxi@mailinator.com",
      phone_number: "(155)810-4736",
      mobile: null,
      url: null,
      image: null,
      created_by: 50,
      updated_by: 50,
      status: 1,
      created_at: "2024-11-12T17:20:14.000000Z",
      updated_at: "2024-11-12T17:20:14.000000Z",
      deleted_at: null,
      ip_address: "103.112.218.174",
      images: [],
      payment: null,
    },
    {
      id: 78,
      cate_id: 20,
      sub_cate_id: 0,
      name: "Tannerr Barry",
      description:
        "Ut nihil animi earum aute nihil obcaecati mollit obcaecati laborum",
      type: "Premium",
      start_date: "2024-11-13",
      meta_description: "",
      meta_keywords: "",
      contact_detail: "Dolor sint qui aperi",
      contact_person_name: "Kalia Ewing",
      email: "ansh.eww@gmail.com",
      phone_number: "9938383889",
      mobile: null,
      url: null,
      image: null,
      created_by: 50,
      updated_by: 50,
      status: 1,
      created_at: "2024-11-12T16:37:29.000000Z",
      updated_at: "2024-11-12T16:37:29.000000Z",
      deleted_at: null,
      ip_address: "103.112.218.174",
      images: [],
      payment: null,
    },
    {
      id: 77,
      cate_id: 20,
      sub_cate_id: 0,
      name: "Tannerr Barry",
      description:
        "Ut nihil animi earum aute nihil obcaecati mollit obcaecati laborum",
      type: "Premium",
      start_date: "2024-11-13",
      meta_description: "",
      meta_keywords: "",
      contact_detail: "Dolor sint qui aperi",
      contact_person_name: "Kalia Ewing",
      email: "ansh.eww@gmail.com",
      phone_number: "9938383889",
      mobile: null,
      url: null,
      image: null,
      created_by: 50,
      updated_by: 50,
      status: 1,
      created_at: "2024-11-12T16:37:04.000000Z",
      updated_at: "2024-11-12T16:37:04.000000Z",
      deleted_at: null,
      ip_address: "103.112.218.174",
      images: [],
      payment: null,
    },
    {
      id: 58,
      cate_id: 3,
      sub_cate_id: 0,
      name: "Tannerr Barry",
      description:
        "Omnis non itaque omnis enim natus elit velit eum porro tenetur",
      type: "Premium",
      start_date: "2024-10-30",
      meta_description: "",
      meta_keywords: "",
      contact_detail: "Dolor sint qui aperi",
      contact_person_name: "Michael Finch",
      email: "ansh.eww@gmail.com",
      phone_number: "9938383883",
      mobile: null,
      url: null,
      image: "1729025485-image.jpg",
      created_by: 50,
      updated_by: 50,
      status: 1,
      created_at: "2024-10-16T03:51:25.000000Z",
      updated_at: "2024-10-16T03:51:25.000000Z",
      deleted_at: null,
      ip_address: "103.112.218.174",
      is_expire: false,
      images: [],
      payment: {
        id: 22,
        user_id: 50,
        classfied_id: 58,
        type: "Premium",
        checkout_id:
          "cs_test_a17RPKIIT7W6r8aYWy80erT6de1J7lhjOSu85JHXbTG1d9t0sVq7eXszHZ",
        amount: "25",
        payment_status: 1,
        purchase_date: "2024-10-15 20:51:26",
        expire_date: "2024-11-14 20:51:25",
        is_current_plan: 1,
        created_at: "2024-10-16T03:51:26.000000Z",
        updated_at: "2024-11-12T17:54:02.000000Z",
        deleted_at: null,
        email_sent: 0,
        email_sent_one: 0,
      },
    },
    {
      id: 57,
      cate_id: 24,
      sub_cate_id: 0,
      name: "Tannerr Barry",
      description:
        "Officia placeat reprehenderit quis aliquid velit perferendis quas et excepteur",
      type: "Premium",
      start_date: "2024-10-24",
      meta_description: "",
      meta_keywords: "",
      contact_detail: "Dolor sint qui aperi",
      contact_person_name: "Louis Bradley",
      email: "ansh.eww@gmail.com",
      phone_number: "9938383883",
      mobile: null,
      url: null,
      image: "1729025335-image.jpg",
      created_by: 50,
      updated_by: 50,
      status: 1,
      created_at: "2024-10-16T03:49:00.000000Z",
      updated_at: "2024-10-16T03:49:00.000000Z",
      deleted_at: null,
      ip_address: "103.112.218.174",
      is_expire: false,
      images: [],
      payment: {
        id: 21,
        user_id: 50,
        classfied_id: 57,
        type: "Premium",
        checkout_id:
          "cs_test_a1fpvpdV7ZNkHzyRmXogQAjWLPNdshKXujjv6In0Mj8kf466nR5wN1QUg9",
        amount: "25",
        payment_status: 1,
        purchase_date: "2024-10-15 20:49:01",
        expire_date: "2024-11-14 20:49:00",
        is_current_plan: 1,
        created_at: "2024-10-16T03:49:01.000000Z",
        updated_at: "2024-11-12T17:54:02.000000Z",
        deleted_at: null,
        email_sent: 0,
        email_sent_one: 0,
      },
    },
    {
      id: 56,
      cate_id: 6,
      sub_cate_id: 0,
      name: "Marcia Valentine",
      description:
        "Labore asperiores quia quos officia qui dolores est quaerat maiores unde placeat ut esse",
      type: "Premium",
      start_date: "2024-10-23",
      meta_description: "",
      meta_keywords: "",
      contact_detail: "Et perferendis et es",
      contact_person_name: "Lani Hood",
      email: "sylyku@mailinator.com",
      phone_number: "7997939393",
      mobile: null,
      url: null,
      image: null,
      created_by: 50,
      updated_by: 50,
      status: 1,
      created_at: "2024-10-16T03:31:20.000000Z",
      updated_at: "2024-10-16T03:31:20.000000Z",
      deleted_at: null,
      ip_address: "103.112.218.174",
      is_expire: false,
      images: [],
      payment: {
        id: 20,
        user_id: 50,
        classfied_id: 56,
        type: "Premium",
        checkout_id:
          "cs_test_a1vO0Sjt9wKP1xxCnM2XzmNdOvcJyQ0Jvky9ArMkDiWTjyqtYoAQzCA9vH",
        amount: "25",
        payment_status: 1,
        purchase_date: "2024-10-15 20:31:20",
        expire_date: "2024-11-14 20:31:20",
        is_current_plan: 1,
        created_at: "2024-10-16T03:31:20.000000Z",
        updated_at: "2024-11-12T17:54:02.000000Z",
        deleted_at: null,
        email_sent: 0,
        email_sent_one: 0,
      },
    },
  ],
  business: [
    {
      id: 1098,
      name: "Brittany Donovan",
      cate_id: 22,
      member: "non_member",
      type: "Premium",
      start_date: null,
      description:
        "Architecto voluptate veritatis dolorum officia error in velit voluptatem est ratione quam nulla eiusmod non",
      url: "https://azindia.n2nhostings.com/",
      state_id: 21,
      city_id: 22,
      zip_code: 23295,
      address:
        "Nostrum deserunt voluptatem consectetur et nobis adipisicing ea nostrum consequuntur dolores et dignissimos assumenda dolore quis doloremque elit odit",
      image: "1729106020-image.jpg",
      phone_number: "1763827758",
      created_by: 50,
      updated_by: 50,
      created_at: "2024-10-17T02:13:40.000000Z",
      updated_at: "2024-10-17T02:13:40.000000Z",
      deleted_at: null,
      status: 1,
      ip_address: "103.112.218.174",
      is_expire: false,
      payment: {
        id: 28,
        user_id: 50,
        business_id: 1098,
        type: "Premium",
        checkout_id:
          "cs_test_a1Mz79OuHNj5kb5WTatTy4F5kumiyVNidSM9K7g0zfyMujtPg1Ku4KkIjo",
        amount: "25",
        payment_status: 1,
        purchase_date: "2024-10-16 19:13:41",
        expire_date: "2024-11-15 19:13:40",
        is_current_plan: 1,
        created_at: "2024-10-17T02:13:41.000000Z",
        updated_at: "2024-10-17T02:14:07.000000Z",
        deleted_at: null,
        email_sent: 0,
        email_sent_one: 0,
      },
    },
    {
      id: 1090,
      name: "Regina Singleton",
      cate_id: 40,
      member: "member",
      type: "Premium",
      start_date: null,
      description:
        "Ipsa est elit impedit fugiat rem assumenda sunt officia autem ad blanditiis quidem et do laboriosam",
      url: "https://google.com",
      state_id: 20,
      city_id: 408,
      zip_code: 93939,
      address: "Sit quo sit qui qui necessitatibus impedit exercitation ut",
      image: "1728940796-image.jpg",
      phone_number: "4494994940",
      created_by: 50,
      updated_by: 50,
      created_at: "2024-10-15T04:19:56.000000Z",
      updated_at: "2024-10-16T22:35:19.000000Z",
      deleted_at: null,
      status: 1,
      ip_address: "103.112.218.174",
      is_expire: true,
      payment: {
        id: 20,
        user_id: 50,
        business_id: 1090,
        type: "Premium",
        checkout_id:
          "cs_test_a1gncwLMfg0HsBj5PwocvzdWn0EEtL2QA7OyhqilXUKBsXA6VqPP5Cx9wW",
        amount: "25",
        payment_status: 1,
        purchase_date: "2024-10-14 21:19:56",
        expire_date: "2024-11-13 21:19:56",
        is_current_plan: 1,
        created_at: "2024-10-15T04:19:56.000000Z",
        updated_at: "2024-10-17T02:14:07.000000Z",
        deleted_at: null,
        email_sent: 0,
        email_sent_one: 0,
      },
    },
  ],
  job: [
    {
      id: 23,
      sub_cate_id: 7,
      date: "2024-10-26",
      description: "Numquam adipisicing commodo natus esse dolorum alias",
      contact_detail: "Optio autem odio ve",
      name: "Nevada Walker",
      email: "beqafo@mailinator.com",
      phone: "9499494944",
      mobile: "",
      company_name: "Rivers and Estrada LLC",
      location: "Deleniti beatae cons",
      map_url: null,
      show_my_contact: 1,
      created_by: 50,
      updated_by: 50,
      status: 1,
      image: "1729013061-image.jpg",
      created_at: "2024-10-16T00:24:21.000000Z",
      updated_at: "2024-10-25T16:48:57.000000Z",
      deleted_at: null,
      ip_address: "103.112.218.174",
      is_expire: false,
      payment: {
        id: 20,
        job_id: 23,
        user_id: 50,
        type: "Premium",
        checkout_id:
          "cs_test_a1yqROddakHX0VvUnXaYDGiY1ApH5tz1nmDXWc96WgP9ptLxtvCUhN9cUd",
        amount: "25",
        payment_status: 1,
        purchase_date: "2024-10-15 17:24:22",
        expire_date: "2024-11-25 00:00:00",
        is_current_plan: 1,
        created_at: "2024-10-16T00:24:22.000000Z",
        updated_at: "2024-10-16T00:24:47.000000Z",
        deleted_at: null,
        email_sent: 0,
        email_sent_one: 0,
      },
    },
    {
      id: 11,
      sub_cate_id: 2,
      date: "2024-10-16",
      description: "Quo harum tempore dolore ut voluptas et fugiat illum",
      contact_detail: "Optio vero vel impe",
      name: "Ori Sears",
      email: "jemolico@mailinator.com",
      phone: "9838848488",
      mobile: "",
      company_name: "Kane and Gilbert Associates",
      location: "Dolore similique inc",
      map_url: "Eiusmod voluptatem",
      show_my_contact: 1,
      created_by: 50,
      updated_by: 50,
      status: 0,
      image: null,
      created_at: "2024-10-08T14:25:05.000000Z",
      updated_at: "2024-10-25T16:40:55.000000Z",
      deleted_at: null,
      ip_address: "103.112.218.174",
      is_expire: false,
      payment: {
        id: 8,
        job_id: 11,
        user_id: 50,
        type: "Premium",
        checkout_id:
          "cs_test_a17tBTl9VPgylBnh9lgN9ANAv40gaJ8hkGlpzcAAorqN0A8UaX2V0kNoMR",
        amount: "25",
        payment_status: 1,
        purchase_date: "2024-10-08 07:25:06",
        expire_date: "2024-11-15 00:00:00",
        is_current_plan: 1,
        created_at: "2024-10-08T14:25:06.000000Z",
        updated_at: "2024-10-16T00:24:47.000000Z",
        deleted_at: null,
        email_sent: 0,
        email_sent_one: 0,
      },
    },
  ],
  megaphone: [],
  event: [
    {
      id: 91,
      name: "Lawrence Mcleod",
      type_id: 5,
      association_id: null,
      image: "1731165989-image.jpg",
      description: "<p>dsadasdasdasd lorem ipsum&nbsp;</p>",
      sponsor_logo: "1731165989-logo.jpg",
      sponsor_email_logo: "1731165989-spo-email.jpg",
      flyer: "1731165989-flyer.jpg",
      sponsor_url: null,
      ticket_url: null,
      created_at: "2024-11-09T15:26:29.000000Z",
      updated_at: "2024-11-09T15:26:29.000000Z",
      created_by: 50,
      updated_by: 50,
      status: 1,
      admin_status: 0,
      payment_type: "Premium",
      deleted_at: null,
      ip_address: "42.106.9.79",
      type: "Premium",
      location: [
        {
          id: 175,
          event_id: 91,
          location_id: 15,
          date: "2024-11-14",
          time: "20:00:00",
          created_at: "2024-11-09T15:26:29.000000Z",
          updated_at: "2024-11-09T15:26:29.000000Z",
        },
      ],
      payment: {
        id: 30,
        user_id: 50,
        event_id: 91,
        type: "Premium",
        checkout_id:
          "cs_test_a1EtVPxrHvfa9zJkPSrHYWnURZiV6wcOkxzLFrDudcyvVIqhQ8sJmJCk24",
        amount: "25",
        payment_status: 1,
        purchase_date: "2024-11-09 08:26:29",
        expire_date: "2024-12-09 08:26:29",
        is_current_plan: 1,
        created_at: "2024-11-09T15:26:29.000000Z",
        updated_at: "2024-11-09T15:27:12.000000Z",
        deleted_at: null,
      },
      video: [
        {
          id: 93,
          event_id: 91,
          link: "https://www.vawowynarozum.org",
          created_at: "2024-11-09T15:26:29.000000Z",
          updated_at: "2024-11-09T15:26:29.000000Z",
        },
      ],
    },
    {
      id: 90,
      name: "Pandora Humphrey",
      type_id: 5,
      association_id: null,
      image: null,
      description: "<p>sadasdasdasd</p>",
      sponsor_logo: null,
      sponsor_email_logo: null,
      flyer: "1731165922-flyer.png",
      sponsor_url: null,
      ticket_url: null,
      created_at: "2024-11-09T15:25:25.000000Z",
      updated_at: "2024-11-09T15:25:25.000000Z",
      created_by: 50,
      updated_by: 50,
      status: 1,
      admin_status: 0,
      payment_type: "Standard",
      deleted_at: null,
      ip_address: "42.106.9.79",
      type: "Standard",
      location: [
        {
          id: 174,
          event_id: 90,
          location_id: 17,
          date: "2024-11-12",
          time: "21:15:00",
          created_at: "2024-11-09T15:25:25.000000Z",
          updated_at: "2024-11-09T15:25:25.000000Z",
        },
      ],
      payment: null,
      video: [
        {
          id: 92,
          event_id: 90,
          link: "https://www.jagiwyzutymowa.us",
          created_at: "2024-11-09T15:25:25.000000Z",
          updated_at: "2024-11-09T15:25:25.000000Z",
        },
      ],
    },
    {
      id: 82,
      name: "name",
      type_id: 24,
      association_id: null,
      image: null,
      description:
        "<p>&nbsp;</p><p><strong>Lorem Ipsum</strong> is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p><p>&nbsp;</p><h2>It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy. Various versions have evolved over the years, sometimes by accident, sometimes on purpose (injected humour and the like).<br>&nbsp;</h2><p>&nbsp;</p><h2>Where does it come from?</h2><p>Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source. Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of \"de Finibus Bonorum et Malorum\" (The Extremes of Good and Evil) by Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very popular during the Renaissance. The first line of Lorem Ipsum, \"Lorem ipsum dolor sit amet..\", comes from a line in section 1.10.32.</p><p>The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested. Sections 1.10.32 and 1.10.33 from \"de Finibus Bonorum et Malorum\" by Cicero are also reproduced in their exact original form, accompanied by English versions from the 1914 translation by H. Rackham.</p><p>&nbsp;</p><h2>Where can I get some?</h2><p>There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable. If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text. All the Lorem Ipsum generators on the Internet tend to repeat predefined chunks as necessary, making this the first true generator on the Internet. It uses a dictionary of over 200 Latin words, combined with a handful of model sentence structures, to generate Lorem Ipsum which looks reasonable. The generated Lorem Ipsum is therefore always free from repetition, injected humour, or non-characteristic words etc.paragraphswordsbyteslistsStart with 'Lorem<br>ipsum dolor sit amet...'<br>&nbsp;</p><p><br><strong>Lorem Ipsum</strong> is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p><p>&nbsp;</p><p><br>&nbsp;</p><h2>&nbsp;</h2><p>It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy. Various versions have evolved over the years, sometimes by accident, sometimes on purpose (injected humour and the like).&nbsp;</p><p>&nbsp;</p><p><br>&nbsp;</p><h2>&nbsp;</h2><p>Where does it come from?</p><p>&nbsp;</p><p>Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source. Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of \"de Finibus Bonorum et Malorum\" (The Extremes of Good and Evil) by Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very popular during the Renaissance. The first line of Lorem Ipsum, \"Lorem ipsum dolor sit amet..\", comes from a line in section 1.10.32.</p><p>&nbsp;</p><p>The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested. Sections 1.10.32 and 1.10.33 from \"de Finibus Bonorum et Malorum\" by Cicero are also reproduced in their exact original form, accompanied by English versions from the 1914 translation by H. Rackham.</p><p>&nbsp;</p><p><br>&nbsp;</p><h2>&nbsp;</h2><p>Where can I get some?</p><p>&nbsp;</p><p>There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable. If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text. All the Lorem Ipsum generators on the Internet tend to repeat predefined chunks as necessary, making this the first true generator on the Internet. It uses a dictionary of over 200 Latin words, combined with a handful of model sentence structures, to generate Lorem Ipsum which looks reasonable. The generated Lorem Ipsum is therefore always free from repetition, injected humour, or non-characteristic words etc.paragraphswordsbyteslistsStart with 'Loremipsum dolor sit amet...'<br>&nbsp;</p>",
      sponsor_logo: null,
      sponsor_email_logo: null,
      flyer: "1729615600-flyer.jpg",
      sponsor_url: null,
      ticket_url: null,
      created_at: "2024-10-22T23:46:40.000000Z",
      updated_at: "2024-10-22T23:48:26.000000Z",
      created_by: 50,
      updated_by: 1,
      status: 1,
      admin_status: 1,
      payment_type: "Premium",
      deleted_at: null,
      ip_address: "103.112.218.174",
      type: "Premium",
      location: [
        {
          id: 126,
          event_id: 82,
          location_id: 367,
          date: "2024-10-25",
          time: "22:30:00",
          created_at: "2024-10-22T23:48:26.000000Z",
          updated_at: "2024-10-22T23:48:26.000000Z",
        },
      ],
      payment: {
        id: 23,
        user_id: 50,
        event_id: 82,
        type: "Premium",
        checkout_id:
          "cs_test_a1z7ErHfwi6zkUQzJTUEdEfJoje569KVnd8QpLFDPTRoppBUP8ruNTTOjo",
        amount: "25",
        payment_status: 1,
        purchase_date: "2024-10-22 16:46:41",
        expire_date: "2024-11-21 16:46:40",
        is_current_plan: 1,
        created_at: "2024-10-22T23:46:41.000000Z",
        updated_at: "2024-11-09T15:27:12.000000Z",
        deleted_at: null,
      },
      video: [
        {
          id: 65,
          event_id: 82,
          link: "https://youtu.be/yuY67Nls_kA?si=jojsEDfszLPOQ7us",
          created_at: "2024-10-22T23:48:26.000000Z",
          updated_at: "2024-10-22T23:48:26.000000Z",
        },
      ],
    },
    {
      id: 81,
      name: "name",
      type_id: 27,
      association_id: 50,
      image: null,
      description: "<p>dummy textt</p>",
      sponsor_logo: null,
      sponsor_email_logo: null,
      flyer: "1729609737-flyer.jpg",
      sponsor_url: null,
      ticket_url: null,
      created_at: "2024-10-22T22:09:00.000000Z",
      updated_at: "2024-10-22T22:12:47.000000Z",
      created_by: 50,
      updated_by: 50,
      status: 1,
      admin_status: 0,
      payment_type: "Premium",
      deleted_at: null,
      ip_address: "103.112.218.174",
      type: "Premium",
      location: [
        {
          id: 124,
          event_id: 81,
          location_id: 370,
          date: "2024-10-24",
          time: "20:45:00",
          created_at: "2024-10-22T22:12:47.000000Z",
          updated_at: "2024-10-22T22:12:47.000000Z",
        },
      ],
      payment: {
        id: 22,
        user_id: 50,
        event_id: 81,
        type: "Premium",
        checkout_id:
          "cs_test_a1DKTjcYIDFLx2yR2DSE5TzEdO6wqdOgUxgU9XQKvsUMp6tjSzIjdcd5lp",
        amount: "25",
        payment_status: 1,
        purchase_date: "2024-10-22 15:09:02",
        expire_date: "2024-11-21 15:09:00",
        is_current_plan: 1,
        created_at: "2024-10-22T22:09:02.000000Z",
        updated_at: "2024-11-09T15:27:12.000000Z",
        deleted_at: null,
      },
      video: [
        {
          id: 63,
          event_id: 81,
          link: "https://youtu.be/f5NJQiY9AuY?si=YH4xa-jYkbtaKVWI",
          created_at: "2024-10-22T22:12:47.000000Z",
          updated_at: "2024-10-22T22:12:47.000000Z",
        },
      ],
    },
    {
      id: 73,
      name: "test event",
      type_id: 27,
      association_id: null,
      image: null,
      description: "<p>test location&nbsp;</p>",
      sponsor_logo: null,
      sponsor_email_logo: null,
      flyer: "1728940467-flyer.jpg",
      sponsor_url: null,
      ticket_url: null,
      created_at: "2024-10-15T04:14:27.000000Z",
      updated_at: "2024-10-15T04:14:27.000000Z",
      created_by: 50,
      updated_by: 50,
      status: 1,
      admin_status: 0,
      payment_type: "Premium",
      deleted_at: null,
      ip_address: "103.112.218.174",
      type: "Premium",
      location: [
        {
          id: 108,
          event_id: 73,
          location_id: 370,
          date: "2024-10-17",
          time: "02:30:00",
          created_at: "2024-10-15T04:14:27.000000Z",
          updated_at: "2024-10-15T04:14:27.000000Z",
        },
      ],
      payment: {
        id: 14,
        user_id: 50,
        event_id: 73,
        type: "Premium",
        checkout_id:
          "cs_test_a1IrkKgbBVzyXGcv3h3X1y0GZnliVbQiMNBzYk8X1O39IP4pncuw24Md2B",
        amount: "25",
        payment_status: 1,
        purchase_date: "2024-10-14 21:14:27",
        expire_date: null,
        is_current_plan: 1,
        created_at: "2024-10-15T04:14:27.000000Z",
        updated_at: "2024-11-09T15:27:12.000000Z",
        deleted_at: null,
      },
      video: [
        {
          id: 49,
          event_id: 73,
          link: "https://www.google.org.au",
          created_at: "2024-10-15T04:14:27.000000Z",
          updated_at: "2024-10-15T04:14:27.000000Z",
        },
      ],
    },
    {
      id: 72,
      name: "event name",
      type_id: 6,
      association_id: null,
      image: null,
      description: "<p>details</p>",
      sponsor_logo: null,
      sponsor_email_logo: null,
      flyer: null,
      sponsor_url: null,
      ticket_url: null,
      created_at: "2024-10-10T20:18:09.000000Z",
      updated_at: "2024-10-10T20:18:09.000000Z",
      created_by: 50,
      updated_by: 50,
      status: 1,
      admin_status: 0,
      payment_type: "Standard",
      deleted_at: null,
      ip_address: "103.112.218.174",
      type: "Standard",
      location: [
        {
          id: 107,
          event_id: 72,
          location_id: 38,
          date: "2024-10-23",
          time: "18:45:00",
          created_at: "2024-10-10T20:18:09.000000Z",
          updated_at: "2024-10-10T20:18:09.000000Z",
        },
      ],
      payment: null,
      video: [
        {
          id: 48,
          event_id: 72,
          link: null,
          created_at: "2024-10-10T20:18:09.000000Z",
          updated_at: "2024-10-10T20:18:09.000000Z",
        },
      ],
    },
    {
      id: 71,
      name: "event name",
      type_id: 6,
      association_id: null,
      image: null,
      description: "<p>details</p>",
      sponsor_logo: null,
      sponsor_email_logo: null,
      flyer: null,
      sponsor_url: null,
      ticket_url: null,
      created_at: "2024-10-10T20:14:34.000000Z",
      updated_at: "2024-10-10T20:14:34.000000Z",
      created_by: 50,
      updated_by: 50,
      status: 1,
      admin_status: 0,
      payment_type: "Standard",
      deleted_at: null,
      ip_address: "103.112.218.174",
      type: "Standard",
      location: [
        {
          id: 106,
          event_id: 71,
          location_id: 38,
          date: "2024-10-23",
          time: "18:45:00",
          created_at: "2024-10-10T20:14:34.000000Z",
          updated_at: "2024-10-10T20:14:34.000000Z",
        },
      ],
      payment: null,
      video: [
        {
          id: 47,
          event_id: 71,
          link: null,
          created_at: "2024-10-10T20:14:34.000000Z",
          updated_at: "2024-10-10T20:14:34.000000Z",
        },
      ],
    },
  ],
};
